module.exports = __webpack_public_path__ + "static/media/guideline3Up.d5fe3110.png";